import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';

function getIconJsxByDirection(direction) {
  if (direction === 'up') {
    return React.createElement("g", {
      transform: "translate(14.000000, 8.000000) scale(-1, 1) translate(-14.000000, -8.000000) ",
      id: "Shape"
    }, React.createElement("path", {
      d: "M9.79162026,7.98656035 L21.519265,-3.39372341 C22.1335771,-3.99027617 22.1350057,-4.95585912 21.5206937,-5.55241188 C20.909239,-6.14896463 19.9120534,-6.14896463 19.2991701,-5.55379912 L6.46004912,6.90444139 C6.15146437,7.20271777 5.99860072,7.59394543 6,7.98517295 C5.99860072,8.37640061 6.15146437,8.76762828 6.45862048,9.0672919 L19.3163136,21.5532792 C19.6234697,21.8515555 20.0249155,22 20.4277899,22 C20.8306643,22 21.23211,21.8515555 21.539266,21.5532792 C22.153578,20.9567264 22.153578,19.9911435 21.539266,19.3945907 L9.79162026,7.98656035 Z",
      transform: "translate(14.000000, 8.000000) rotate(90.000000) translate(-14.000000, -8.000000) "
    }));
  }

  if (direction === 'left') {
    return React.createElement("g", {
      transform: "translate(8.000000, 14.000000) rotate(-90.000000) translate(-8.000000, -14.000000) translate(-6.000000, 6.000000)",
      id: "Shape"
    }, React.createElement("path", {
      d: "M9.79162635,7.98656035 L21.5192711,-3.39372341 C22.1335832,-3.99027617 22.1350118,-4.95585912 21.5206997,-5.55241188 C20.9092451,-6.14896463 19.9120595,-6.14896463 19.2991762,-5.55379912 L6.4600552,6.90444139 C6.15147046,7.20271777 5.9986068,7.59394543 6.00000609,7.98517295 C5.9986068,8.37640061 6.15147046,8.76762828 6.45862656,9.0672919 L19.3163197,21.5532792 C19.6234758,21.8515555 20.0249216,22 20.427796,22 C20.8306703,22 21.2321161,21.8515555 21.539272,21.5532792 C22.1535841,20.9567264 22.1535841,19.9911435 21.539272,19.3945907 L9.79162635,7.98656035 Z",
      transform: "translate(14.000006, 8.000000) rotate(90.000000) translate(-14.000006, -8.000000) "
    }));
  }

  if (direction === 'right') {
    return React.createElement("g", {
      transform: "translate(8.000000, 14.000000) rotate(90.000000) translate(-8.000000, -14.000000) translate(-6.000000, 6.000000)",
      id: "Shape"
    }, React.createElement("path", {
      d: "M9.79161417,7.98656035 L21.5192589,-3.39372341 C22.133571,-3.99027617 22.1349996,-4.95585912 21.5206876,-5.55241188 C20.909233,-6.14896463 19.9120473,-6.14896463 19.299164,-5.55379912 L6.46004303,6.90444139 C6.15145828,7.20271777 5.99859463,7.59394543 5.99999391,7.98517295 C5.99859463,8.37640061 6.15145828,8.76762828 6.45861439,9.0672919 L19.3163075,21.5532792 C19.6234636,21.8515555 20.0249094,22 20.4277838,22 C20.8306582,22 21.2321039,21.8515555 21.5392599,21.5532792 C22.1535719,20.9567264 22.1535719,19.9911435 21.5392599,19.3945907 L9.79161417,7.98656035 Z",
      transform: "translate(13.999994, 8.000000) rotate(90.000000) translate(-13.999994, -8.000000)"
    }));
  }

  return React.createElement("g", {
    transform: "translate(14.000000, 8.000000) rotate(-90.000000) translate(-14.000000, -8.000000) translate(6.000000, -6.000000)",
    id: "Shape"
  }, React.createElement("path", {
    d: "M3.79161417,13.9865664 L15.5192589,2.60628268 C16.133571,2.00972992 16.1349996,1.04414697 15.5206876,0.44759421 C14.909233,-0.148958546 13.9120473,-0.148958546 13.299164,0.446206965 L0.460043029,12.9044475 C0.151458285,13.2027239 -0.00140536918,13.5939515 -6.0859611e-06,13.985179 C-0.00140536918,14.3764067 0.151458285,14.7676344 0.458614391,15.067298 L13.3163075,27.5532853 C13.6234636,27.8515616 14.0249094,28.0000061 14.4277838,28.0000061 C14.8306582,28.0000061 15.2321039,27.8515616 15.5392599,27.5532853 C16.1535719,26.9567325 16.1535719,25.9911495 15.5392599,25.3945968 L3.79161417,13.9865664 Z"
  }));
}

export default function Chevron(_ref) {
  var color = _ref.color,
      height = _ref.height,
      width = _ref.width,
      className = _ref.className,
      direction = _ref.direction,
      rest = _objectWithoutProperties(_ref, ["color", "height", "width", "className", "direction"]);

  return React.createElement("span", _extends({
    className: className
  }, rest), React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 28 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "chevron_".concat(direction),
    fill: color
  }, getIconJsxByDirection(direction)))));
}
Chevron.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  direction: PropTypes.oneOf(['up', 'down', 'left', 'right'])
};
Chevron.defaultProps = {
  color: '#63666A',
  className: undefined,
  height: '10px',
  width: '20px',
  direction: 'down'
};